export default function AdminOrders(){return <div className='p-8'>Admin Orders</div>}